// module.exports = {
//   title: '鲸动管理中心',
//   /**
//    * settings
//    * @type {boolean} true | false
//    * @description Whether fix the header
//    */
//   fixedHeader: false,
//   /**
//    * @type {boolean} true | false
//    * @description Whether show the logo in sidebar
//    */
//   /**
//    * 侧边栏logo
//    */
//   sidebarLogo: false,
//   // api 接口路径基础路径
//   apiDomain: 'http://api.0ba.top/basic/v1',
//   domainUrl: 'http://domain.xt.com',
//   // domainUrl: 'http://d.iyes.com',
//   // 单点登录域名
//   ssoLoginAddress: 'http://sso.tuner.com/',
//   // 单点退出域名
//   ssoLogoutAddress: 'http://sso.tuner.com/logout?backUrl=',
// }

var baseDomain = {}
baseDomain.cookieDomain = 'jdmob.cn'
baseDomain.appId = '159'
baseDomain.global = false
baseDomain.sidebarLogo = false
baseDomain.fixedHeader = false
baseDomain.title = '鲸动精准营销平台'
// 获取当前网页的协议+域名
function getPageBaseUrl() {
  let baseURL = ''
  if (!window.location.origin) { // 兼容IE，IE11版本下location.origin为undefined
    window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
  } else {
    baseURL = window.location.origin
  }
  return baseURL
}
var baseURL = getPageBaseUrl()

/*
  production:线上部署环境   打包命令:npm run build
  test:测试部署环境         打包命令：npm run test
  development：本地开发环境   本地运行:npm run dev
*/
if (process.env.NODE_ENV === 'production') {
  baseDomain.pageConfig = {
    'limit': 10,
    'sizes': [10, 20, 30, 40, 50, 100]

  }
  baseDomain.interFaceDomain = "https://api.jdmob.cn/jdFront/v3"
  baseDomain.dicDomain = "https://api.jdmob.cn/basic/v1"
  baseDomain.locatDomain = baseURL
  baseDomain.webDomain = 'http://www.jdmob.cn'
} else if (process.env.NODE_ENV === 'development') {
  baseDomain.pageConfig = {
    'limit': 10,
    'sizes': [10, 20, 30, 40, 50, 100]

  }
  // api 接口路径基础路径
  baseDomain.apiDomain = 'http://api.0ba.top/basic/v1'
  // baseDomain.interFaceDomain = "http://api.dev.cn/jdFront/v3"
  // baseDomain.dicDomain = "http://api.dev.cn/basic/v1"
  baseDomain.interFaceDomain = "http://api.0cg.top/jdFront/v3"
  baseDomain.dicDomain = "http://api.0cg.top/basic/v1"
  baseDomain.locatDomain = baseURL
  baseDomain.webDomain = 'http://www.jdmob.cn'

} else if (process.env.NODE_ENV === 'test') {
  baseDomain.pageConfig = {
    'limit': 10,
    'sizes': [10, 20, 30, 40, 50, 100]

  }
  baseDomain.interFaceDomain = "http://api.0cg.top/jdFront/v3"
  baseDomain.dicDomain = "http://api.0cg.top/basic/v1"
  baseDomain.locatDomain = baseURL
  baseDomain.webDomain = 'http://www.jdmob.cn'
}
export default baseDomain
